import DOMPurify from 'dompurify';
import { marked } from 'marked';

const getHtmlFromMarkdown = (text: string): string => {
  return DOMPurify.sanitize(marked.parse(text, { async: false }));
};

export default getHtmlFromMarkdown;
